import React from 'react'
import { useInfiniteQuery } from 'react-query'
import cn from 'classnames'
import { useRouter } from 'next/router'

import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { ChapterStatusEnum } from '@interfaces/ChapterStatusEnum'
import { useChapterAction } from '@hooks/chapter/useChapterAction'
import { Loading } from '@components/Loading'
import { SelectChapterForWriterProps } from './interface'
import { SelectChapter } from '../SelectChapter'

const limit = 12

export function SelectChapterForWriter({
  bookId,
}: SelectChapterForWriterProps) {
  const chapterClient = useChapterAction()
  const router = useRouter()
  const { isDarkTheme, isNightTheme, isLightTheme, isSepiaTheme } = useTheme()

  const { fetchNextPage, data, isFetchingNextPage } = useInfiniteQuery(
    ['book', bookId, 'chapters'],
    async ({ pageParam = 1 }) => {
      const res = await chapterClient.bookChapterOptions(
        bookId,
        pageParam,
        limit
      )

      return res
    },
    {
      getNextPageParam: (lastPage: any) => {
        if (lastPage.chapters.length) return lastPage.page + 1

        return undefined
      },
    }
  )

  return (
    <SelectChapter
      onScroll={(e: any) => {
        const scrollHeight = e.target.scrollHeight - 10
        const scrollTop = e.target.scrollTop + e.target.offsetHeight
        if (scrollHeight <= scrollTop && !isFetchingNextPage) {
          fetchNextPage()
        }
      }}
    >
      {data?.pages.map(page =>
        page?.chapters.map(chapter => {
          const disable = chapter.status === ChapterStatusEnum.RESTRICTED

          return (
            <div
              key={chapter.id}
              className={cn({
                'cursor-pointer': !disable,
                'cursor-not-allowed': disable,
              })}
              onClick={() => {
                if (disable) {
                  return
                }

                router.push(`/my-writing/${bookId}/chapter/${chapter.id}`)
              }}
            >
              <SelectChapter.Item
                isDarkTheme={isDarkTheme}
                isNightTheme={isNightTheme}
                isLightTheme={isLightTheme}
                isSepiaTheme={isSepiaTheme}
              >
                {chapter.chapterTitle} {chapter.chapterName}
              </SelectChapter.Item>
            </div>
          )
        })
      )}
      {isFetchingNextPage && <Loading className='mx-auto' size={20} />}
    </SelectChapter>
  )
}
